export let ChangeThumbnailTab = /*#__PURE__*/function (ChangeThumbnailTab) {
  /** Tab from where an image can be selected from the existing image gallery  */
  ChangeThumbnailTab["gallery"] = "Gallery";
  /** Tab from where an image can be uploaded from computer  */
  ChangeThumbnailTab["computer"] = "From computer";
  return ChangeThumbnailTab;
}({});

/** Represents the type of subject for which the thumbnail is being changed */
export let ThumbnailSubjectType = /*#__PURE__*/function (ThumbnailSubjectType) {
  ThumbnailSubjectType["project"] = "Project";
  ThumbnailSubjectType["group"] = "Group";
  return ThumbnailSubjectType;
}({});